import React, {useState, useRef, useEffect} from 'react';
import { styled } from "styled-components";
import Button from "../button/button";
import ErrorMessage from "../messages/error";
import apiService from "../../data/service/apiService";
import useUserStore from "../../data/store/useUserStore";
import { t } from 'ttag';

const FormBox = styled.div`
  .resendCode {
    color: #9738FF;
  }
  .phoneInp {
    background-color: #F5F5F5;
    padding: 10px 15px;
    margin: 10px;
    border: 0px;
    padding-left: 15px!important;
    width: 40px;
  }
  .wrongData {
    color: #F7326D;
    font-variant-numeric: lining-nums proportional-nums;
    font-family: Raleway;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
  
  @media (max-width: 768px) {
    .phoneInp {
      padding: 6px;
      margin: 5px;
      width: 36px;
    }
    .inpSectionBlock {
      display: flex;
      justify-content: center;
      margin-bottom: 16px;
    }
  }
`;

const ConfirmationSmsCode = ({ phoneNumber, onSubmit, goBack }) => {
  const { setUserInfo } = useUserStore();
  const [isValid, setIsValid] = useState(true);
  const [isDisabledBtn, setDisabledBtn] = useState(true);

  const inputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null)
  ];

  const [codes, setCodes] = useState(['', '', '', '', '', '']);

  useEffect(() => {
    setDisabledBtn(!(codes.every(code => code.length === 1)));
  }, [codes]);

  useEffect(() => {
    inputRefs[0].current.focus();
  }, []);

  const handleInputChange = (index, value) => {

    if (!Number(value) && value != '0' && value != '') {
      return false;
    }

    const newCodes = [...codes];
    newCodes[index] = value;
    setCodes(newCodes);
    setIsValid(true);

    if (index < 7 && value.length === 1) {
      if (inputRefs[index + 1] && inputRefs[index + 1].current) {
        inputRefs[index + 1].current.focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && index > 0 && codes[index] === '') {
      inputRefs[index - 1].current.focus();
    }
  };

  const hidePhoneNumber = (phoneNumber) => {
    if (!phoneNumber || phoneNumber.length < 6) {
      return phoneNumber;
    }

    const firstPart = phoneNumber.slice(0, 2);
    const middlePart = '*'.repeat(phoneNumber.length - 5);
    const lastPart = phoneNumber.slice(-2);

    return `${firstPart}${middlePart}${lastPart}`;
  };

  const onSave = () => {
    setDisabledBtn(true);

    apiService.post('/auth', {
      phoneNumber: phoneNumber,
      otpAttempt: codes.join('')
    }).then(data => {
      if (data.errors) {
        setIsValid(false);
      } else {
        if (data.token) {
          setUserInfo({
            phone: phoneNumber,
            token: data.token
          });

          sessionStorage.setItem('token', data.token);
          sessionStorage.setItem('webSmsOptOutAvailable', data.webOptOutAvailable === true ? 'true' : 'false');
        }

        if (onSubmit) {
          onSubmit();
        }
      }
    }).catch(err => {
      console.log('err >> ', err);
    });
  };

  const resendCode = (e) => {
    goBack();
    e.preventDefault();
  };

  return (
    <FormBox>
      <h2>{t`Confirmation code`}</h2>
      <div className="row">
        <label htmlFor="smsCodeInput">
          <p>
            {t`We’ve sent a code to your phone number`}{' '}
            +{hidePhoneNumber(phoneNumber)} . {t`Type the code from the message below`}:
          </p>
        </label>
        <div className='inpSectionBlock'>
          {codes.map((code, index) => {
            return <input
              id={`smsCodeInput_${index}`}
              key={index}
              ref={inputRefs[index]}
              className="phoneInp"
              type="text"
              value={code}
              onChange={(e) => handleInputChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              maxLength={1}
            />
          })}
        </div>
      </div>
      {!isValid && <ErrorMessage text={t`Wrong SMS code`} />}
      <div className="row">
        <a href="#" className="resendCode" onClick={resendCode}>
          {t`Resend the code`}
        </a>
      </div>
      <Button className="mt-3" title={t`Proceed`} onClick={onSave} disabled={isDisabledBtn || !isValid} />
    </FormBox>
  );
};

export default ConfirmationSmsCode;
